<script setup>
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted, reactive, computed } from 'vue';

const { t } = useI18n();

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  }
});
const emit = defineEmits(['update:visible']);

const { locale } = useI18n();

const helpCenterURLData = import.meta.env.VITE_HELP_CENTER_URL.split(',');
const contactURLData = import.meta.env.VITE_CONTACT_URL.split(',');

const user = ref();
const localVisible = ref(props.visible);

const helpCenterURL = computed(() => {
  switch (locale.value) {
    case 'fr': return helpCenterURLData[0];
    case 'en': return helpCenterURLData[1];
    case 'de': return helpCenterURLData[2];
    case 'es': return helpCenterURLData[3];
    case 'it': return helpCenterURLData[4];
    case 'pt': return helpCenterURLData[5];
    default: return 'https://lc.cx';
  }
});

const contactURL = computed(() => {
  switch (locale.value) {
    case 'fr': return contactURLData[0];
    case 'en': return contactURLData[1];
    case 'de': return contactURLData[2];
    case 'es': return contactURLData[3];
    case 'it': return contactURLData[4];
    case 'pt': return contactURLData[5];
    default: return 'https://lc.cx';
  }
});

async function handleShow() {
  user.value = JSON.parse(localStorage.getItem('user'));
}

function handleHide() {
  emit('update:visible', false);
}

watch(
  () => props.visible,
  (newValue) => {
    localVisible.value = newValue;
  }
)
</script>


<template>
  <Dialog @hide="handleHide" @show="handleShow" v-model:visible="localVisible" modal
    :header="t('support.title')" :style="{ width: '25rem' }">
    <div class="flex flex-col gap-2 mb-4">
      <p>{{ t('support.help') }}</p>
    </div>
    <div class="flex gap-2 mb-8">
      <Button as="a" :href="helpCenterURL" type="button" :label="t('support.actions.helpcenter')" target="_blank"
        severity="primary"></Button>
    </div>
    <div class="flex flex-col gap-2 mb-4">
      <p>{{ t('support.question') }}</p>
    </div>
    <div class="flex gap-2 mb-8">
      <Button as="a" :href="contactURL" type="button" :label="t('support.actions.contactus')" target="_blank"
        severity="primary"></Button>
    </div>
    <div class="flex justify-end gap-2">
      <Button type="button" :label="t('common.labels.close')" severity="secondary" @click="handleHide"></Button>
    </div>
  </Dialog>
</template>